import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=4de4fd6f&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de4fd6f')) {
      api.createRecord('4de4fd6f', component.options)
    } else {
      api.reload('4de4fd6f', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=4de4fd6f&", function () {
      api.rerender('4de4fd6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4OfNen6H71g7H/JS/pricehelp.vue"
export default component.exports